// Block Text Items: every item is sticky (block-text-items.css), the next one sliding up over it.
// An item taller than the screen would stick with its lower part out of view, and the next item
// covered it before it was ever seen. So each item's height is kept in --text-items-item-height,
// and the CSS lets a tall item stick only once its bottom edge reaches the bottom of the screen.

export function initBlockTextItems(): void {
    const items = document.querySelectorAll<HTMLElement>(".block-text-items__item");
    if (items.length === 0 || !("ResizeObserver" in window)) {
        return;
    }

    const observer = new ResizeObserver((entries) => {
        for (const entry of entries) {
            const height = entry.borderBoxSize?.[0]?.blockSize ?? (entry.target as HTMLElement).offsetHeight;
            (entry.target as HTMLElement).style.setProperty("--text-items-item-height", `${Math.ceil(height)}px`);
        }
    });
    items.forEach((item) => observer.observe(item));
}
